import React, { useEffect } from "react";
import "./CustomAlert.css";

interface CustomAlertProps {
  message: string;
  type: "success" | "error" | "warning";
  onClose: () => void;
}

const CustomAlert: React.FC<CustomAlertProps> = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // auto-close after 3 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast-alert ${type}`}>
      <span className="emoji">
        {type === "success" ? "✅" : type === "error" ? "❌" : "⚠️"}
      </span>
      <span className="msg">{message}</span>
    </div>
  );
};

export default CustomAlert;
